/* import dotenv from "dotenv";
dotenv.config(); */
// Fonction pour formater un montant avec des points comme séparateurs de milliers
const formatMontant = (montant) => {
  // Utiliser Intl.NumberFormat pour un formatage optimisé des nombres
  return new Intl.NumberFormat("fr-FR", {
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(montant);
};

// Fonction pour générer une chaîne aléatoire
const generateRandomString = (length) => {
  return crypto
    .randomBytes(Math.ceil(length / 2))
    .toString("hex")
    .slice(0, length);
};

// Fonction pour générer un code de parrainage
const genererCodeParrainage = (longueur) => {
  return Math.random()
    .toString()
    .slice(2, longueur + 2);
};

// Fonction pour copier du texte dans le presse-papier
const copierDansPressePapier = async (texte) => {
  try {
    await navigator.clipboard.writeText(texte);
  } catch (err) {

  }
};

// const env = "dev";
const env = process.env.ENVIRONEMENT;

// Prime IDs
const primeReservationId = process.env.PRIME_RESERVATION_ID;
const primeLogementId = process.env.PRIME_LOGEMENT_ID;
const primeHoteId = process.env.PRIME_HOTE_ID;

// Adresses
const adresses = {
  back: {
    local: process.env.BACK_LOCAL,
    dev: process.env.BACK_DEV,
    preprod: process.env.BACK_PREPROD,
    prod: process.env.BACK_PROD,
  },
  /* front: () => {
    if (typeof window !== "undefined") {
      return window.location.origin;
    }
    // Fallback pour le rendu côté serveur (SSR) ou autres environnements non-navigateur
    return process.env.FRONT_PROD;
  }, */
  front: {
    local: process.env.FRONT_LOCAL,
    dev: process.env.FRONT_DEV,
    preprod: process.env.FRONT_PREPROD,
    prod: process.env.FRONT_PROD,
  },
};

// const frontAdresse = adresses.front() ?? null;
let frontAdresse = adresses.front[env];
let backAdresse = adresses.back[env];

// ⚠️ FALLBACK: Si les variables sont undefined, détecter automatiquement l'environnement
if (!frontAdresse || !backAdresse) {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Détecter l'environnement selon le hostname
    if (hostname === 'awlohub.com') {
      frontAdresse = 'https://awlohub.com';
      backAdresse = 'https://back.awlohub.com/';
    } else if (hostname === 'beta.awlohub.com') {
      frontAdresse = 'https://beta.awlohub.com';
      backAdresse = 'https://preprod.back.awlohub.com/';
    } else if (hostname === 'alpha.awlohub.com') {
      frontAdresse = 'https://alpha.awlohub.com';
      backAdresse = 'https://dev.back.awlohub.com/';
    } else {
      // Local
      frontAdresse = 'http://localhost:9000';
      backAdresse = 'http://localhost:8055/';
    }
  }
}

// Constantes de paiement
const checkPayment = {
  wave: {
    local: process.env.WAVE_LOCAL,
    dev: process.env.WAVE_DEV,
    preprod: process.env.WAVE_PREPROD,
    prod: process.env.WAVE_PROD,
  },
  cinetpay: {
    local: process.env.CINETPAY_LOCAL,
    dev: process.env.CINETPAY_DEV,
    preprod: process.env.CINETPAY_PREPROD,
    prod: process.env.CINETPAY_PROD,
  },
};

const webHook = {
  checkPayment_wave: checkPayment.wave[env],
  checkPayment_cinetpay: checkPayment.cinetpay[env],
};

// Variables de base de données
const variableDB = {
  firstStep: {
    heros:
      backAdresse === adresses.back.prod
        ? "0c7c8e45-d5ab-4d4f-aaaa-58ba4cc42936"
        : backAdresse === adresses.back.local
        ? "44f0a780-e554-44b1-a3bd-60ec44bb1da8"
        : "4848f396-66b7-40a5-a782-725d0b5d0cf6",
    hoteFirst:
      backAdresse === adresses.back.prod
        ? "225e2dca-9266-483f-8b41-b3d35643c544"
        : backAdresse === adresses.back.local
        ? "753a1974-154c-4be0-be63-54238723c462"
        : "fe8d786b-72b6-40ac-92f2-5cacad298211",
    hoteSecond:
      backAdresse === adresses.back.prod
        ? "6ea3eab3-ea28-48cb-8bdc-ac9694d4f790"
        : backAdresse === adresses.back.local
        ? "186d2496-3862-469d-a116-8876096640e3"
        : "5a060442-eb94-4ab9-a3aa-6a6effc14ca1",
    demarcheurFirst:
      backAdresse === adresses.back.prod
        ? "5cd2e7ec-fc94-494b-95e6-9a1519e326d7"
        : backAdresse === adresses.back.local
        ? "7d3e4df7-fb38-4a70-be48-914adc8af675"
        : "dab7de24-3757-4b6f-8f79-e18b73806aab",
    demarcheurSecond:
      backAdresse === adresses.back.prod
        ? "fb7d5a7e-395a-4bd3-9807-a3c5e77f9701"
        : backAdresse === adresses.back.local
        ? "c9239c60-6931-4a6f-adb1-d2cc58784b3a"
        : "f54e58fb-2d60-4a96-ac69-1eac4257c22f",
    voyageurFirst:
      backAdresse === adresses.back.prod
        ? "70f9abee-5010-4bb8-8c63-aaefa68af69e"
        : backAdresse === adresses.back.local
        ? "1e8a4403-145d-411a-9fd7-bc3be5521589"
        : "18ceafc1-7150-407c-afce-8a995f3995d3",
    voyageurSecond:
      backAdresse === adresses.back.prod
        ? "58d97af7-c056-46f3-9daf-4d4930e657ae"
        : backAdresse === adresses.back.local
        ? "815aa2a1-404b-4595-8a55-fd48c6c94ca3"
        : "b0d8d106-ae83-447d-914f-a0c0c1560b91",
  },
};

// Fonctions d'arrondi
const arrondirAuMultipleInferieurDe5 = (valeur) => {
  // Validation de la valeur d'entrée
  if (valeur === null || valeur === undefined || isNaN(valeur)) {
    return 0;
  }

  const valeurNum = typeof valeur === "string" ? parseFloat(valeur) : valeur;
  if (isNaN(valeurNum)) {
    return 0;
  }

  return Math.floor(valeurNum / 5) * 5;
};

const arrondirAuMultipleSuperieurDe5 = (valeur) => {
  // Validation de la valeur d'entrée
  if (valeur === null || valeur === undefined || isNaN(valeur)) {
    return 5; // Retourner le minimum sécurisé
  }

  const valeurNum = typeof valeur === "string" ? parseFloat(valeur) : valeur;
  if (isNaN(valeurNum)) {
    return 5; // Retourner le minimum sécurisé
  }

  // Gestion du cas où la valeur est 0 ou négative
  if (valeurNum <= 0) {
    return 5; // Minimum sécurisé
  }

  try {
    return Math.ceil(valeurNum / 5) * 5;
  } catch (error) {
    // Erreur silencieuse
    return Math.max(5, Math.round(valeurNum)); // Fallback sécurisé
  }
};

export function loadGoogleMaps(apiKey) {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      reject(new Error("Google Maps non disponible en SSR"));
      return;
    }
    if (window.google && window.google.maps) {
      resolve(window.google);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=fr&region=ci&loading=async`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      resolve(window.google);
    };
    script.onerror = () =>
      reject(new Error("Erreur de chargement de Google Maps API"));
    document.head.appendChild(script);
  });
}
function openInSafari(url) {
  const link = document.createElement("a");
  link.href = url;
  link.target = "_blank";
  link.rel = "noopener noreferrer";

  // Simule un clic
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export {
  variableDB,
  frontAdresse,
  backAdresse,
  primeReservationId,
  primeLogementId,
  primeHoteId,
  webHook,
  arrondirAuMultipleInferieurDe5,
  formatMontant,
  generateRandomString,
  copierDansPressePapier,
  genererCodeParrainage,
  arrondirAuMultipleSuperieurDe5,
  openInSafari,
};
